import { useGlobalState } from 'context/GlobalStateContext'
import { useTestingLabSelectTestingLabsQuery } from 'schema'
import { createStrictContext } from 'utils/createContext'
import { DefaultQueryHookOptions } from 'utils/defaults'
import { useOptions } from '../../hooks/useOptions'
import { toLabeledValues } from '../../utils/labeledValues'
import { TestingLabSelectContext } from './types'

const { Provider, useContextFn } = createStrictContext<TestingLabSelectContext>(
  'TestingLabSelectContext'
)

export const useTestingLabSelectContext = useContextFn

const TestingLabSelectProvider: React.FC = ({ children }) => {
  const {
    state: { projectGlobalId: projectId },
  } = useGlobalState()
  const { data, loading } = useTestingLabSelectTestingLabsQuery({
    ...DefaultQueryHookOptions,
    skip: !projectId,
    variables: { projectId: projectId! },
  })
  const options = useOptions({
    items: data?.testingLabs?.records,
    label: 'name',
    value: 'id',
    sort: 'name',
  })
  return (
    <Provider
      value={{
        options,
        loading,
        fromLabeledValue: (value) => value?.value as number,
        fromLabeledValues: (values) =>
          (values ?? []).map(({ value }) => value as number),
        toLabeledValue: (lab) =>
          lab ? { label: lab.name, value: lab.id } : undefined,
        toLabeledValues: (records) =>
          toLabeledValues(records, { label: 'name', value: 'id' }),
      }}
    >
      {children}
    </Provider>
  )
}

export default TestingLabSelectProvider
